import { useNavigate } from "react-router-dom"
import { useState, useContext, useEffect, useRef } from "react";
import Button from "react-bootstrap/esm/Button";
import { AuthContext } from "../../context/AuthContext";
import { LoginModalContext } from "../../context/LoginModalContext";
import { onSnapshot, where, and, or, query, collection } from "firebase/firestore";
import { db } from "../../firebase";
import { NavLink } from "react-router-dom";
import sound from "../../assets/audio-vgbonus.wav"
import BottomBar from "./BottomBar";
import { ListingContextProvider } from "../../context/ListingsContext";

const NavbarContainer = () => {
    const [bottomBarNotif, setBottomBarNotif] = useState(0);

    const { currentUser, logout } = useContext(AuthContext)
    const { setLoginModalOpen} = useContext(LoginModalContext)
    const navigate = useNavigate()

    const handleLogout = async () => {
        try {
            await logout()
            navigate("/")
            window.location.reload()
        } catch {
            console.log("error logging out")
        }
    }

    const hamburgerToggle = useRef()
    
    useEffect(() => {
        if (currentUser) {
            const q = query(
                collection(db, "chatrooms"), 
                and(
                    where("lastSender", "!=", currentUser.uid),
                    where("unread", "==", true),
                    or(
                        where("to.uid", "==", currentUser.uid),
                        where("from.uid", "==", currentUser.uid),
                    ),
                )
            )

            let docTitle
            setTimeout(() => {
                docTitle=document.title
            }, 3000)

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                console.log("getting unread chats for navbar")
                const chatsRes = []
                querySnapshot.forEach((doc) => {
                    chatsRes.push(doc.data())
                })
                const width = window.innerWidth;
                if (width < 720) {
                    if (chatsRes && chatsRes.length > 0) {
                        setBottomBarNotif(chatsRes.length)
                    } else {
                        setBottomBarNotif(0)
                    }
                } else {
                    const element = document.getElementById("inbox")
                    if (chatsRes && chatsRes.length > 0) {
                        element.style.setProperty("--unread-chats", `"${chatsRes.length}"`)
                        element.classList.add("unread")
                        // hamburgerToggle.current.classList.add("unread")
                        // hamburgerToggle.current.style.setProperty("--unread-chats", `"${chatsRes.length}"`)
                        document.title = `(${chatsRes.length}) Phreesh - your neighborhood treasure trove`
                    } else {
                        element.classList.remove("unread")
                        // hamburgerToggle.current.classList.remove("unread")
                        document.title = `Phreesh - your neighborhood treasure trove`
                    }
                } 
                setTimeout(() => {
                    if (document.title !== docTitle) {
                        if (parseInt(document.title[1])>parseInt(docTitle[1]) || (document.title[0]==="(" && docTitle[0]!=="(")) {
                            console.log(document.title)
                            console.log(docTitle)
                            const notificationSound = new Audio(sound)
                            notificationSound.volume = 0.1
                            notificationSound.play()
                        }
                        docTitle = document.title
                    }
                }, "5000")
            })
            return () => unsubscribe()
        } 
    }, [])

    return (
        <div className="nav-container">
            <div className="navbar topnav">
                {
                    currentUser ?
                    null:
                    <Button  onClick={() => setLoginModalOpen(true)} className="login-btn">Login</Button>
                }
                <NavLink className="topnav-logo logo" to={{pathname: `/`,}}>
                    Phreesh
                </NavLink>
            </div>
                    {
                        currentUser ? 
                        <div>
                            {/* <label className="hamburger-toggle sidebar-toggle" ref={hamburgerToggle}>
                                <input type="checkbox" id="sidebar-toggle"/>
                            </label> */}
                            <div className="navbar" id="responsive">
                                <NavLink className="logo"  to={{pathname: `/`}} >
                                    Phreesh
                                </NavLink>
                                {/* <a className="logo" href="/">
                                    Phreesh
                                </a> */}
                                <div className="navlinks">
                                {/* <ul className="navbar-nav"> 
                                    <li className="nav-item"> */}
                                        <NavLink className="nav-item hide-on-lrgscreen responsive-logout" to={{pathname: ""}} onClick={handleLogout}>Logout</NavLink>
                                        <NavLink className="nav-item hide-on-lrgscreen" to={{pathname:"/archive"}}>Archive</NavLink>
                                        <NavLink className="nav-item" to={{pathname:"/myoffers"}}>Saved Listings</NavLink>
                                    {/* </li>
                                    <li className="nav-item"> */}
                                        <NavLink className="nav-item" to={{pathname:"/mylistings"}}>My Listings</NavLink>
                                    {/* </li>
                                    <li className="nav-item"> */}
                                        <NavLink className="nav-item" id="inbox" to={{pathname:"/inbox"}}>
                                            Inbox
                                            <span className="inbox-notification-container"/>
                                        </NavLink>
                                        <NavLink className="nav-item" to={{pathname:"/"}}>Home</NavLink>
                                    {/* </li> */}
                                        <div className="hide-on-lrgscreen">
                                            <NavLink className="nav-item sidebar-profile-link" to={{pathname:`/user/${currentUser.uid}`}}>
                                                {currentUser.avatarUrl ?
                                                <img src={currentUser.avatarUrl} className="avatar avatar-nav nav-item hide-on-lrgscreen"/>:
                                                <span className="material-icons avatar avatar-nav hide-on-lrgscreen">account_circle</span>}
                                                {/* <img src={currentUser.avatarUrl ? currentUser.avatarUrl : img1} className="avatar avatar-nav nav-item hide-on-lrgscreen"/> */}
                                                {currentUser.firstName}
                                            </NavLink>
                                        </div>
                                    
                                    <li className="nav-item dropdown hide-on-smlscreen">
                                        {currentUser.avatarUrl ?
                                        <img src={currentUser.avatarUrl} className="avatar avatar-nav nav-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"/>:
                                        <i className="material-icons avatar avatar-nav dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">account_circle</i>}
                                        {/* <img src={currentUser.avatarUrl ? currentUser.avatarUrl : img1} className="avatar avatar-nav nav-item dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"/> */}
                                        <ul className="dropdown-menu" id="dropdown-menu">
                                            <div className="nav-greeting"><span>Hello {currentUser.firstName}!</span></div>
                                            <li><NavLink className="dropdown-item" to={{pathname:`/user/${currentUser.uid}`}}>Profile</NavLink></li>
                                            <li><NavLink className="dropdown-item" to={{pathname:"/archive"}}>Archive</NavLink></li>
                                            <li onClick={handleLogout}><NavLink className="dropdown-item" to={{pathname:""}}>Logout</NavLink></li>
                                        </ul>
                                    </li>
                                {/* </ul>  */}
                                </div>
                            </div>
                        </div>
                        : 
                        <div className="navbar" id="responsive">
                            <NavLink className="logo" to={{pathname:"/"}}>
                                Phreesh
                            </NavLink>
                            <Button  onClick={() => setLoginModalOpen(true)} className="login-btn-responsive">Login</Button>
                        </div>
                    }
            
                <BottomBar bottomBarNotif={bottomBarNotif}/>
        </div>
    )
}

export default NavbarContainer